/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * AutoGPT Agent Server
 * This server is used to execute agents that are created by the AutoGPT system.
 * OpenAPI spec version: 0.1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { BodyUploadCopilotSkillPackage } from "../../models/bodyUploadCopilotSkillPackage.ts";

import type { CopilotSkillDetail } from "../../models/copilotSkillDetail.ts";

import type { CopilotSkillInfo } from "../../models/copilotSkillInfo.ts";

import type { DeleteCopilotSkill200 } from "../../models/deleteCopilotSkill200.ts";

import type { DeleteCopilotSkillParams } from "../../models/deleteCopilotSkillParams.ts";

import type { DownloadCopilotSkillPackageParams } from "../../models/downloadCopilotSkillPackageParams.ts";

import type { HTTP401NotAuthenticatedErrorResponse } from "../../models/hTTP401NotAuthenticatedErrorResponse.ts";

import type { HTTPValidationError } from "../../models/hTTPValidationError.ts";

import type { ListCopilotSkillsParams } from "../../models/listCopilotSkillsParams.ts";

import type { ReadCopilotSkillParams } from "../../models/readCopilotSkillParams.ts";

import type { UploadCopilotSkillPackageParams } from "../../models/uploadCopilotSkillPackageParams.ts";

import type { UploadCopilotSkillParams } from "../../models/uploadCopilotSkillParams.ts";

import type { UploadCopilotSkillRequest } from "../../models/uploadCopilotSkillRequest.ts";

import { customMutator } from "../../../mutators/custom-mutator.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listCopilotSkillsResponse200 = {
  data: CopilotSkillInfo[];
  status: 200;
};

export type listCopilotSkillsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type listCopilotSkillsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listCopilotSkillsResponseSuccess = listCopilotSkillsResponse200 & {
  headers: Headers;
};
export type listCopilotSkillsResponseError = (
  | listCopilotSkillsResponse401
  | listCopilotSkillsResponse422
) & {
  headers: Headers;
};

export type listCopilotSkillsResponse =
  | listCopilotSkillsResponseSuccess
  | listCopilotSkillsResponseError;

export const getListCopilotSkillsUrl = (params?: ListCopilotSkillsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/skills?${stringifiedParams}`
    : `/api/skills`;
};

/**
 * Return the skills owned by personal Otto, or by one expert.
 *
 * Reuses :func:`backend.copilot.tools.skills.list_user_skills` so the
 * library UI sees the exact same set the copilot ``<available_skills>``
 * block surfaces, minus the built-in defaults (which are read-only and
 * handled separately by the copilot runtime).
 * @summary List user-distilled copilot skills
 */
export const listCopilotSkills = async (
  params?: ListCopilotSkillsParams,
  options?: RequestInit,
): Promise<listCopilotSkillsResponse> => {
  return customMutator<listCopilotSkillsResponse>(
    getListCopilotSkillsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListCopilotSkillsQueryKey = (
  params?: ListCopilotSkillsParams,
) => {
  return [`/api/skills`, ...(params ? [params] : [])] as const;
};

export const getListCopilotSkillsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCopilotSkills>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: ListCopilotSkillsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCopilotSkills>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCopilotSkillsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCopilotSkills>>
  > = ({ signal }) => listCopilotSkills(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCopilotSkills>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListCopilotSkillsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCopilotSkills>>
>;
export type ListCopilotSkillsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useListCopilotSkills<
  TData = Awaited<ReturnType<typeof listCopilotSkills>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | ListCopilotSkillsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCopilotSkills>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCopilotSkills>>,
          TError,
          Awaited<ReturnType<typeof listCopilotSkills>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCopilotSkills<
  TData = Awaited<ReturnType<typeof listCopilotSkills>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: ListCopilotSkillsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCopilotSkills>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCopilotSkills>>,
          TError,
          Awaited<ReturnType<typeof listCopilotSkills>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCopilotSkills<
  TData = Awaited<ReturnType<typeof listCopilotSkills>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: ListCopilotSkillsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCopilotSkills>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List user-distilled copilot skills
 */

export function useListCopilotSkills<
  TData = Awaited<ReturnType<typeof listCopilotSkills>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: ListCopilotSkillsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCopilotSkills>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListCopilotSkillsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List user-distilled copilot skills
 */
export const prefetchListCopilotSkillsQuery = async <
  TData = Awaited<ReturnType<typeof listCopilotSkills>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: ListCopilotSkillsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCopilotSkills>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getListCopilotSkillsQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type uploadCopilotSkillResponse201 = {
  data: CopilotSkillInfo;
  status: 201;
};

export type uploadCopilotSkillResponse400 = {
  data: void;
  status: 400;
};

export type uploadCopilotSkillResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type uploadCopilotSkillResponse409 = {
  data: void;
  status: 409;
};

export type uploadCopilotSkillResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type uploadCopilotSkillResponseSuccess =
  uploadCopilotSkillResponse201 & {
    headers: Headers;
  };
export type uploadCopilotSkillResponseError = (
  | uploadCopilotSkillResponse400
  | uploadCopilotSkillResponse401
  | uploadCopilotSkillResponse409
  | uploadCopilotSkillResponse422
) & {
  headers: Headers;
};

export type uploadCopilotSkillResponse =
  | uploadCopilotSkillResponseSuccess
  | uploadCopilotSkillResponseError;

export const getUploadCopilotSkillUrl = (params?: UploadCopilotSkillParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/skills?${stringifiedParams}`
    : `/api/skills`;
};

/**
 * Create a user-distilled skill from an uploaded ``SKILL.md`` file.
 *
 * Parses the canonical frontmatter + body, then reuses
 * :func:`backend.copilot.tools.skills.store_user_skill` so an uploaded skill
 * is validated, capped, and persisted exactly like one the copilot distils
 * via ``store_skill``.  Malformed files return 400, the per-expert cap returns
 * 409, and an existing slug is overwritten (upsert).
 * @summary Upload a copilot skill from a SKILL.md file
 */
export const uploadCopilotSkill = async (
  uploadCopilotSkillRequest: UploadCopilotSkillRequest,
  params?: UploadCopilotSkillParams,
  options?: RequestInit,
): Promise<uploadCopilotSkillResponse> => {
  return customMutator<uploadCopilotSkillResponse>(
    getUploadCopilotSkillUrl(params),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(uploadCopilotSkillRequest),
    },
  );
};

export const getUploadCopilotSkillMutationOptions = <
  TError = void | HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadCopilotSkill>>,
    TError,
    { data: UploadCopilotSkillRequest; params?: UploadCopilotSkillParams },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadCopilotSkill>>,
  TError,
  { data: UploadCopilotSkillRequest; params?: UploadCopilotSkillParams },
  TContext
> => {
  const mutationKey = ["uploadCopilotSkill"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadCopilotSkill>>,
    { data: UploadCopilotSkillRequest; params?: UploadCopilotSkillParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return uploadCopilotSkill(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadCopilotSkillMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadCopilotSkill>>
>;
export type UploadCopilotSkillMutationBody = UploadCopilotSkillRequest;
export type UploadCopilotSkillMutationError =
  | void
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Upload a copilot skill from a SKILL.md file
 */
export const useUploadCopilotSkill = <
  TError = void | HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadCopilotSkill>>,
      TError,
      { data: UploadCopilotSkillRequest; params?: UploadCopilotSkillParams },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadCopilotSkill>>,
  TError,
  { data: UploadCopilotSkillRequest; params?: UploadCopilotSkillParams },
  TContext
> => {
  return useMutation(
    getUploadCopilotSkillMutationOptions(options),
    queryClient,
  );
};
export type uploadCopilotSkillPackageResponse201 = {
  data: CopilotSkillInfo;
  status: 201;
};

export type uploadCopilotSkillPackageResponse400 = {
  data: void;
  status: 400;
};

export type uploadCopilotSkillPackageResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type uploadCopilotSkillPackageResponse409 = {
  data: void;
  status: 409;
};

export type uploadCopilotSkillPackageResponse413 = {
  data: void;
  status: 413;
};

export type uploadCopilotSkillPackageResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type uploadCopilotSkillPackageResponseSuccess =
  uploadCopilotSkillPackageResponse201 & {
    headers: Headers;
  };
export type uploadCopilotSkillPackageResponseError = (
  | uploadCopilotSkillPackageResponse400
  | uploadCopilotSkillPackageResponse401
  | uploadCopilotSkillPackageResponse409
  | uploadCopilotSkillPackageResponse413
  | uploadCopilotSkillPackageResponse422
) & {
  headers: Headers;
};

export type uploadCopilotSkillPackageResponse =
  | uploadCopilotSkillPackageResponseSuccess
  | uploadCopilotSkillPackageResponseError;

export const getUploadCopilotSkillPackageUrl = (
  params?: UploadCopilotSkillPackageParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/skills/package?${stringifiedParams}`
    : `/api/skills/package`;
};

/**
 * Create a skill from a zipped package — a root ``SKILL.md`` plus the
 * files beside it.
 *
 * The zip is transport only: it is unpacked here and stored as the skill's
 * folder, so the model reaches ``scripts/`` and ``references/`` by path
 * exactly as it does for a package copied from another skill.
 * @summary Upload a copilot skill as a zipped package
 */
export const uploadCopilotSkillPackage = async (
  bodyUploadCopilotSkillPackage: BodyUploadCopilotSkillPackage,
  params?: UploadCopilotSkillPackageParams,
  options?: RequestInit,
): Promise<uploadCopilotSkillPackageResponse> => {
  const formData = new FormData();
  formData.append(`file`, bodyUploadCopilotSkillPackage.file);

  return customMutator<uploadCopilotSkillPackageResponse>(
    getUploadCopilotSkillPackageUrl(params),
    {
      ...options,
      method: "POST",
      body: formData,
    },
  );
};

export const getUploadCopilotSkillPackageMutationOptions = <
  TError = void | HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadCopilotSkillPackage>>,
    TError,
    {
      data: BodyUploadCopilotSkillPackage;
      params?: UploadCopilotSkillPackageParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadCopilotSkillPackage>>,
  TError,
  {
    data: BodyUploadCopilotSkillPackage;
    params?: UploadCopilotSkillPackageParams;
  },
  TContext
> => {
  const mutationKey = ["uploadCopilotSkillPackage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadCopilotSkillPackage>>,
    {
      data: BodyUploadCopilotSkillPackage;
      params?: UploadCopilotSkillPackageParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return uploadCopilotSkillPackage(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadCopilotSkillPackageMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadCopilotSkillPackage>>
>;
export type UploadCopilotSkillPackageMutationBody =
  BodyUploadCopilotSkillPackage;
export type UploadCopilotSkillPackageMutationError =
  | void
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Upload a copilot skill as a zipped package
 */
export const useUploadCopilotSkillPackage = <
  TError = void | HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadCopilotSkillPackage>>,
      TError,
      {
        data: BodyUploadCopilotSkillPackage;
        params?: UploadCopilotSkillPackageParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadCopilotSkillPackage>>,
  TError,
  {
    data: BodyUploadCopilotSkillPackage;
    params?: UploadCopilotSkillPackageParams;
  },
  TContext
> => {
  return useMutation(
    getUploadCopilotSkillPackageMutationOptions(options),
    queryClient,
  );
};
export type deleteCopilotSkillResponse200 = {
  data: DeleteCopilotSkill200;
  status: 200;
};

export type deleteCopilotSkillResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type deleteCopilotSkillResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteCopilotSkillResponseSuccess =
  deleteCopilotSkillResponse200 & {
    headers: Headers;
  };
export type deleteCopilotSkillResponseError = (
  | deleteCopilotSkillResponse401
  | deleteCopilotSkillResponse422
) & {
  headers: Headers;
};

export type deleteCopilotSkillResponse =
  | deleteCopilotSkillResponseSuccess
  | deleteCopilotSkillResponseError;

export const getDeleteCopilotSkillUrl = (
  name: string,
  params?: DeleteCopilotSkillParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/skills/${name}?${stringifiedParams}`
    : `/api/skills/${name}`;
};

/**
 * Delete a user-distilled skill by slug.
 *
 * Built-in defaults are not user-deletable — attempting to delete one
 * returns 400.  Missing skills return 404 so the UI can reconcile a
 * stale list.  409 means the delete could not be ordered with another
 * change to the owner's skills; nothing was deleted, so try again.
 * @summary Delete a user-distilled copilot skill
 */
export const deleteCopilotSkill = async (
  name: string,
  params?: DeleteCopilotSkillParams,
  options?: RequestInit,
): Promise<deleteCopilotSkillResponse> => {
  return customMutator<deleteCopilotSkillResponse>(
    getDeleteCopilotSkillUrl(name, params),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteCopilotSkillMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCopilotSkill>>,
    TError,
    { name: string; params?: DeleteCopilotSkillParams },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCopilotSkill>>,
  TError,
  { name: string; params?: DeleteCopilotSkillParams },
  TContext
> => {
  const mutationKey = ["deleteCopilotSkill"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCopilotSkill>>,
    { name: string; params?: DeleteCopilotSkillParams }
  > = (props) => {
    const { name, params } = props ?? {};

    return deleteCopilotSkill(name, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCopilotSkillMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCopilotSkill>>
>;

export type DeleteCopilotSkillMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Delete a user-distilled copilot skill
 */
export const useDeleteCopilotSkill = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCopilotSkill>>,
      TError,
      { name: string; params?: DeleteCopilotSkillParams },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCopilotSkill>>,
  TError,
  { name: string; params?: DeleteCopilotSkillParams },
  TContext
> => {
  return useMutation(
    getDeleteCopilotSkillMutationOptions(options),
    queryClient,
  );
};
export type readCopilotSkillResponse200 = {
  data: CopilotSkillDetail;
  status: 200;
};

export type readCopilotSkillResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type readCopilotSkillResponse404 = {
  data: void;
  status: 404;
};

export type readCopilotSkillResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type readCopilotSkillResponseSuccess = readCopilotSkillResponse200 & {
  headers: Headers;
};
export type readCopilotSkillResponseError = (
  | readCopilotSkillResponse401
  | readCopilotSkillResponse404
  | readCopilotSkillResponse422
) & {
  headers: Headers;
};

export type readCopilotSkillResponse =
  | readCopilotSkillResponseSuccess
  | readCopilotSkillResponseError;

export const getReadCopilotSkillUrl = (
  name: string,
  params?: ReadCopilotSkillParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/skills/${name}?${stringifiedParams}`
    : `/api/skills/${name}`;
};

/**
 * Return full SKILL.md content (name, description, triggers, body)
 * for the library UI's expand-to-view dialog.
 *
 * Built-in default skills are returned with ``is_default=True`` so the
 * UI can hide destructive affordances; missing user skills return 404.
 * @summary Read a single copilot skill with its full SKILL.md body
 */
export const readCopilotSkill = async (
  name: string,
  params?: ReadCopilotSkillParams,
  options?: RequestInit,
): Promise<readCopilotSkillResponse> => {
  return customMutator<readCopilotSkillResponse>(
    getReadCopilotSkillUrl(name, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getReadCopilotSkillQueryKey = (
  name: string,
  params?: ReadCopilotSkillParams,
) => {
  return [`/api/skills/${name}`, ...(params ? [params] : [])] as const;
};

export const getReadCopilotSkillQueryOptions = <
  TData = Awaited<ReturnType<typeof readCopilotSkill>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  name: string,
  params?: ReadCopilotSkillParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readCopilotSkill>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReadCopilotSkillQueryKey(name, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof readCopilotSkill>>
  > = ({ signal }) =>
    readCopilotSkill(name, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: name !== null && name !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof readCopilotSkill>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReadCopilotSkillQueryResult = NonNullable<
  Awaited<ReturnType<typeof readCopilotSkill>>
>;
export type ReadCopilotSkillQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

export function useReadCopilotSkill<
  TData = Awaited<ReturnType<typeof readCopilotSkill>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  name: string,
  params: undefined | ReadCopilotSkillParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readCopilotSkill>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof readCopilotSkill>>,
          TError,
          Awaited<ReturnType<typeof readCopilotSkill>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReadCopilotSkill<
  TData = Awaited<ReturnType<typeof readCopilotSkill>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  name: string,
  params?: ReadCopilotSkillParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readCopilotSkill>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof readCopilotSkill>>,
          TError,
          Awaited<ReturnType<typeof readCopilotSkill>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReadCopilotSkill<
  TData = Awaited<ReturnType<typeof readCopilotSkill>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  name: string,
  params?: ReadCopilotSkillParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readCopilotSkill>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Read a single copilot skill with its full SKILL.md body
 */

export function useReadCopilotSkill<
  TData = Awaited<ReturnType<typeof readCopilotSkill>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  name: string,
  params?: ReadCopilotSkillParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readCopilotSkill>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getReadCopilotSkillQueryOptions(name, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Read a single copilot skill with its full SKILL.md body
 */
export const prefetchReadCopilotSkillQuery = async <
  TData = Awaited<ReturnType<typeof readCopilotSkill>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  queryClient: QueryClient,
  name: string,
  params?: ReadCopilotSkillParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readCopilotSkill>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getReadCopilotSkillQueryOptions(name, params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type downloadCopilotSkillPackageResponse200 = {
  data: Blob;
  status: 200;
};

export type downloadCopilotSkillPackageResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type downloadCopilotSkillPackageResponse404 = {
  data: void;
  status: 404;
};

export type downloadCopilotSkillPackageResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type downloadCopilotSkillPackageResponseSuccess =
  downloadCopilotSkillPackageResponse200 & {
    headers: Headers;
  };
export type downloadCopilotSkillPackageResponseError = (
  | downloadCopilotSkillPackageResponse401
  | downloadCopilotSkillPackageResponse404
  | downloadCopilotSkillPackageResponse422
) & {
  headers: Headers;
};

export type downloadCopilotSkillPackageResponse =
  | downloadCopilotSkillPackageResponseSuccess
  | downloadCopilotSkillPackageResponseError;

export const getDownloadCopilotSkillPackageUrl = (
  name: string,
  params?: DownloadCopilotSkillPackageParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/skills/${name}/package?${stringifiedParams}`
    : `/api/skills/${name}/package`;
};

/**
 * Return the skill's whole folder as a zip — ``SKILL.md`` at the root,
 * siblings at their relative paths, executable bits preserved — so a
 * download re-uploads to the same tree.
 *
 * Built-in defaults are single on-disk files and are not downloadable here;
 * GET ``/skills/{name}`` serves their body.
 * @summary Download a copilot skill as a zipped package
 */
export const downloadCopilotSkillPackage = async (
  name: string,
  params?: DownloadCopilotSkillPackageParams,
  options?: RequestInit,
): Promise<downloadCopilotSkillPackageResponse> => {
  return customMutator<downloadCopilotSkillPackageResponse>(
    getDownloadCopilotSkillPackageUrl(name, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getDownloadCopilotSkillPackageQueryKey = (
  name: string,
  params?: DownloadCopilotSkillPackageParams,
) => {
  return [`/api/skills/${name}/package`, ...(params ? [params] : [])] as const;
};

export const getDownloadCopilotSkillPackageQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadCopilotSkillPackage>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  name: string,
  params?: DownloadCopilotSkillPackageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadCopilotSkillPackage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadCopilotSkillPackageQueryKey(name, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadCopilotSkillPackage>>
  > = ({ signal }) =>
    downloadCopilotSkillPackage(name, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: name !== null && name !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadCopilotSkillPackage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadCopilotSkillPackageQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadCopilotSkillPackage>>
>;
export type DownloadCopilotSkillPackageQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

export function useDownloadCopilotSkillPackage<
  TData = Awaited<ReturnType<typeof downloadCopilotSkillPackage>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  name: string,
  params: undefined | DownloadCopilotSkillPackageParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadCopilotSkillPackage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadCopilotSkillPackage>>,
          TError,
          Awaited<ReturnType<typeof downloadCopilotSkillPackage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadCopilotSkillPackage<
  TData = Awaited<ReturnType<typeof downloadCopilotSkillPackage>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  name: string,
  params?: DownloadCopilotSkillPackageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadCopilotSkillPackage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadCopilotSkillPackage>>,
          TError,
          Awaited<ReturnType<typeof downloadCopilotSkillPackage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadCopilotSkillPackage<
  TData = Awaited<ReturnType<typeof downloadCopilotSkillPackage>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  name: string,
  params?: DownloadCopilotSkillPackageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadCopilotSkillPackage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download a copilot skill as a zipped package
 */

export function useDownloadCopilotSkillPackage<
  TData = Awaited<ReturnType<typeof downloadCopilotSkillPackage>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  name: string,
  params?: DownloadCopilotSkillPackageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadCopilotSkillPackage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDownloadCopilotSkillPackageQueryOptions(
    name,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Download a copilot skill as a zipped package
 */
export const prefetchDownloadCopilotSkillPackageQuery = async <
  TData = Awaited<ReturnType<typeof downloadCopilotSkillPackage>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  queryClient: QueryClient,
  name: string,
  params?: DownloadCopilotSkillPackageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadCopilotSkillPackage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getDownloadCopilotSkillPackageQueryOptions(
    name,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};
